var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "errorContainer",
    { attrs: { error: _vm.erreur, warning: _vm.warning } },
    [
      _c("transition", { attrs: { name: "slide" } }, [
        _c(
          "div",
          {
            staticClass: "container-layout details-document-package",
            class: {
              "container-layout": _vm.$screen.width > 576,
              "container-mobile": _vm.$screen.width <= 576,
            },
          },
          [
            _c(
              "div",
              { staticClass: "form" },
              [
                _c(
                  "b-row",
                  [
                    _c("b-col", { attrs: { md: "12" } }, [
                      _c(
                        "h1",
                        {
                          class: [
                            `${!_vm.$screen.sm ? "main-page-title" : ""}`,
                            { "is-pwa": _vm.$isPwa() },
                          ],
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t" +
                              _vm._s(_vm.caption1) +
                              "\n\t\t\t\t\t\t"
                          ),
                        ]
                      ),
                    ]),
                  ],
                  1
                ),
                _c(
                  "b-row",
                  { staticClass: "mt-3" },
                  [
                    _c(
                      "b-col",
                      { staticClass: "p-0" },
                      [
                        _c(
                          "b-card",
                          { attrs: { "no-body": "" } },
                          [
                            _c(
                              "b-row",
                              {
                                staticClass:
                                  "back-with-title cursol-pointer py-1",
                              },
                              [
                                _c("b-col", { attrs: { cols: "6" } }, [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn-transparent",
                                      on: { click: _vm.handleClickBack },
                                    },
                                    [
                                      _c("arrow-left", {
                                        staticClass: "icon",
                                        attrs: {
                                          color: "rgba(6, 38, 62, 0.65)",
                                          size: 22,
                                        },
                                      }),
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            display: "inline-block",
                                            color: "#2e495d",
                                            "font-weight": "bolder",
                                            "font-size": "16px",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                              _vm._s(_vm.FormMSG(163, "Back")) +
                                              "\n\t\t\t\t\t\t\t\t\t\t"
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ]),
                              ],
                              1
                            ),
                            _c("b-card-text", [
                              _c(
                                "div",
                                { staticClass: "container-field mt-3" },
                                [
                                  _c(
                                    "b-row",
                                    [
                                      _c(
                                        "b-col",
                                        { attrs: { cols: "6" } },
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                label: _vm.FormMSG(
                                                  110,
                                                  "Total salaries for this function:"
                                                ),
                                                "label-for": "salaries",
                                              },
                                            },
                                            [
                                              _c("b-form-input", {
                                                attrs: {
                                                  disabled: true,
                                                  value: this.displayCurrency(
                                                    this.curBudgetDataDepCat
                                                      .amountTotal
                                                  ),
                                                  type: "text",
                                                  id: "salaries",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "b-row",
                                    { staticClass: "mb-3" },
                                    [
                                      _vm.$screen.width >= 992
                                        ? _c(
                                            "b-col",
                                            { attrs: { cols: "6" } },
                                            [
                                              _vm.$screen.width >= 992
                                                ? _c(
                                                    "b-input-group",
                                                    [
                                                      _c("b-form-input", {
                                                        attrs: {
                                                          type: "text",
                                                          placeholder:
                                                            this.FormMSG(
                                                              12,
                                                              "Type to Search"
                                                            ),
                                                        },
                                                        model: {
                                                          value: _vm.filter,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.filter = $$v
                                                          },
                                                          expression: "filter",
                                                        },
                                                      }),
                                                      _c(
                                                        "b-input-group-append",
                                                        {
                                                          staticClass:
                                                            "cursor-pointer",
                                                        },
                                                        [
                                                          _c(
                                                            "b-input-group-text",
                                                            {
                                                              staticClass:
                                                                "btn-search",
                                                            },
                                                            [
                                                              _vm.filter
                                                                .length === 0
                                                                ? _c("Search", {
                                                                    staticClass:
                                                                      "icon",
                                                                    attrs: {
                                                                      color:
                                                                        "#FFFFFF",
                                                                      size: 16,
                                                                      "stroke-width": 2.5,
                                                                    },
                                                                  })
                                                                : _c("X", {
                                                                    staticClass:
                                                                      "icon",
                                                                    attrs: {
                                                                      color:
                                                                        "#FFFFFF",
                                                                      size: 16,
                                                                      "stroke-width": 2.5,
                                                                    },
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          _vm.filter =
                                                                            ""
                                                                        },
                                                                    },
                                                                  }),
                                                            ],
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "b-row",
                                    [
                                      _c(
                                        "b-col",
                                        { attrs: { cols: "12", xl: "12" } },
                                        [
                                          _c("CardListBuilder", {
                                            attrs: {
                                              "custom-class": "hide-on-desktop",
                                              filter: _vm.filter,
                                              fields: _vm.bgFields,
                                              items: _vm.Users,
                                            },
                                            scopedSlots: _vm._u([
                                              {
                                                key: "actions",
                                                fn: function (data) {
                                                  return [
                                                    _c(
                                                      "b-button",
                                                      {
                                                        attrs: {
                                                          variant: "primary",
                                                          size: "sm",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.rowClicked(
                                                              data.item
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "icon-pencil",
                                                        }),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ]),
                                          }),
                                          _c("b-table", {
                                            staticClass: "hide-on-tablet",
                                            staticStyle: {
                                              "text-align": "left",
                                            },
                                            attrs: {
                                              hover: _vm.hover,
                                              responsive: "sm",
                                              "sticky-header": "700px",
                                              filter: _vm.filter,
                                              items: _vm.Users,
                                              fields: _vm.bgFields,
                                              "current-page": _vm.currentPage,
                                              "per-page": _vm.perPage,
                                              "head-variant": _vm.hv,
                                              bordered: "",
                                              small: "",
                                              "show-empty": "",
                                              "empty-text": _vm.FormMSG(
                                                265,
                                                "No salaries found"
                                              ),
                                            },
                                            on: {
                                              "row-clicked": _vm.rowClicked,
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c("loading", {
                                    attrs: {
                                      active: _vm.isLoading,
                                      "is-full-page": true,
                                      color: "#00A09C",
                                    },
                                    on: {
                                      "update:active": function ($event) {
                                        _vm.isLoading = $event
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }